export default "__VITE_ASSET__CBi9I4lt__"